// survey-success-modal.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-aridos-survey-success-modal',
    templateUrl: './survey-success-modal.component.html',
    styleUrls: ['./survey-success-modal.component.css'],
    standalone: false
})
export class AridosSurveySuccessModalComponent {

  
  constructor(
    private dialogRef: MatDialogRef<AridosSurveySuccessModalComponent>,
    private router: Router
  ) {}

  close() {
    this.dialogRef.close();
    this.router.navigate(['/pedidospendiente']);
  }
}

